/* eslint-disable max-lines-per-function */
import React from "react";
import { navigate, useLocation } from "@reach/router";
// import { Link, useLocation } from "@reach/router";
// import css from "classnames";
import { useQuery } from "@apollo/client";
import { ListItemIcon, ListItemText, MenuItem } from "@material-ui/core";
import { BarChart, Cake, Chat, Close, Language, Group, Search } from "@material-ui/icons";
import { getViewer_viewer as Viewer, ReportSidebarQuery } from "types/gql-types";
// import styles from "../reports.module.css";
import { reportSidebarQuery } from "../query";

const icons = {
  "fa-globe": Language,
  "fa-bar-chart": BarChart,
  "fa-stack-exchange": Chat,
  "fa-times": Close,
  "fa-users": Group,
  "fa-birthday-cake": Cake,
  "fa-search": Search,
} as const;
interface NavLinkProps {
  href: string;
  icon: keyof typeof icons;
  text: string;
}

const NavLink = (props: NavLinkProps) => {
  const location = useLocation();
  const Icon = icons[props.icon];
  return (
    <MenuItem href={props.href} selected={!!location.pathname.match(props.href)} dense
      onClick={(e) => {
        e.preventDefault();
        navigate(props.href);
      }}
    >
      <ListItemIcon style={{ minWidth: "36px" }}>
        <Icon />
      </ListItemIcon>
      <ListItemText>
        {props.text}
      </ListItemText>
    </MenuItem>
  );
};

export const Sidebar: React.FC<{ viewer: Viewer }> = (props) => {
  const { data, error } = useQuery<ReportSidebarQuery>(reportSidebarQuery);
  if (error) return <div>Error loading sidebar</div>;

  return (
    <>
      <h1>Reports</h1>
      <h5 style={{ fontSize: 15 }}>Waitlist Reports</h5>
      <NavLink
        href="applications-received"
        icon="fa-bar-chart"
        text="Applications Received"
      />
      <NavLink
        href="application-source"
        icon="fa-stack-exchange"
        text="Application Source"
      />
      <NavLink
        href="application-status"
        icon="fa-times"
        text="Application Move-Ins / Removals"
      />

      {data?.organization?.asksDobInterestQuestion && (
        <NavLink
          href= "application-dob"
          icon= "fa-birthday-cake"
          text= "Head of Household Age"
        />
      )}
      <NavLink
        href="application-ethnicity"
        icon="fa-globe"
        text="HoH Ethnicity Demographics"
      />
      <NavLink
        href="application-race"
        icon="fa-globe"
        text="HoH Racial Demographics"
      />
      <NavLink
        href="application-gender"
        icon="fa-globe"
        text="HoH Gender Demographics"
      />

      {props.viewer.isSupervisor && (
        <>
          <h5 style={{ fontSize: 15, marginTop: 20 }}>Supervisor Reports</h5>
          <NavLink
            href= "user-stats"
            icon= "fa-users"
            text= "Logins by User"
          />
          <NavLink
            href= "fraud-detection"
            icon= "fa-search"
            text= "Fraud Detection"
          />
        </>
      )}
    </>
  );
};
